import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LinkResponse } from '../../business-partner-support/services/business-partner.service';

@Injectable()
export class EndCustomerService {
    constructor(private http: HttpClient) {}

    checkLogin(loginId: string): Observable<boolean> {
        const url = `${environment.http.usersBaseUrl}users/check-user-login?loginId=${encodeURIComponent(loginId)}`;
        return this.http.get<{ userAlreadyExists: boolean }>(url).pipe(map((response) => response.userAlreadyExists));
    }

    checkPassword(password: string): Observable<boolean> {
        const url = `${environment.http.usersBaseUrl}users/check-user-password`;
        const body: CheckPasswordData = {
            password,
            type: 'consumer',
        };
        return this.http.post<{ valid: boolean }>(url, body).pipe(map((response) => response.valid));
    }
    getDocuments(): Observable<Documents> {
        const url = `${environment.http.legalBaseUrl}apps/${environment.legalAppIdEndCustomer}/documents/`;
        return this.http.get<any>(url).pipe(
            map((docs) => {
                const documents = docs.documents.map((doc) => ({
                    title: doc.title,
                    revisionId: doc.revisionId,
                    language: doc.locale,
                    country: doc.country,
                    href: doc.link,
                }));
                return { documents };
            }),
        );
    }

    createConsumerAccount(consumer: Consumer, createBusinessPartner: boolean): Observable<HttpResponse<LinkResponse>> {
        if (consumer.address.houseNumber) {
            consumer.address.houseNumber = String(consumer.address.houseNumber);
        }

        if (consumer.address.postalCode) {
            consumer.address.postalCode = String(consumer.address.postalCode);
        }

        if (consumer?.address?.region) {
            consumer.address.region = String(consumer.address.region);
        }

        let params = new HttpParams();
        if (createBusinessPartner && !consumer.token) {
            params = params.append('createSapConsumer', 'true');
        }

        const url = `${environment.http.usersBaseUrl}users/consumer`;
        return this.http.post<LinkResponse>(url, consumer, { params, observe: 'response' });
    }

    validateAddress(address: Address): Observable<Address[]> {
        return this.http.post<Address[]>(`${environment.http.usersBaseUrl}users/check-address`, address);
    }
}

export interface Address {
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    countryCode?: string;
    region?: string;
}

export interface Contacts {
    email: string;
}

export interface ConsumerName {
    title?: string;
    firstName: string;
    familyName: string;
}

export interface Consumer {
    loginId: string;
    acceptedDocuments: string[];
    optIn: boolean;
    appId: string;
    languageCode: string;
    gender?: 'MALE' | 'FEMALE' | 'OTHER';
    birthDate?: string;
    name: ConsumerName;
    address?: Address;
    contacts: Contacts;
    password?: string;
    invitationId?: string;
    redirectLink?: string;
    token?: string;
}

export interface CheckPasswordData {
    password: string;
    type: 'consumer' | 'customer';
}

export interface Documents {
    documents: Document[];
}

export interface Document {
    href: string;
    revisionId: string;
    title: string;
    language: string;
    country: string;
}
